import { useSelector } from 'react-redux';
import { differenceInCalendarDays } from 'date-fns';

import useCurrentKitAndTinyAccount from './useCurrentKitAndTinyAccount';
import { getBirthMotherForTinyAccountId } from 'store/account';
import { getKitsForTinyAccountId } from 'store/kits';
import TinyAccount from 'types/TinyAccount';
import { parseDate } from '@repo/utils';
import { RootState } from 'store/store';

// Seeding is information related to a baby kit and a mother kit (at least)
// This hook will organize the information related to a kit ID in such a way so it doesn't matter if you currently have the mother or the kit id
export const useSeedingInfo = () => {
  const { currentKit, currentKitId, currentTinyAccount } =
    useCurrentKitAndTinyAccount();

  const birthMother = useSelector((state: RootState) =>
    currentTinyAccount?.birth_mother_id
      ? getBirthMotherForTinyAccountId(currentTinyAccount.birth_mother_id)(
          state,
        )
      : null,
  );

  const birthMotherKits = useSelector((state: RootState) =>
    currentTinyAccount?.birth_mother_id
      ? getKitsForTinyAccountId(currentTinyAccount.birth_mother_id)(state)
      : [],
  );

  let babyTA: TinyAccount | null = null;
  let momTA: TinyAccount | null = null;
  let matchSeedingCriteria = false;

  if (!currentTinyAccount || !currentKitId) {
    return { babyTA: null, momTA: null, matchSeedingCriteria: false };
  }

  const isBabyUnder7Months = (currentKit?.age_at_sampling ?? 0) < 211;

  if (isBabyUnder7Months) {
    //The current kit is the baby kit
    babyTA = currentTinyAccount;
    momTA = birthMother;

    //Search for a kit from the mom that is between 210 days of baby's birthday (pregnant or post_partum)
    const momKitsMatchingCriteria = birthMotherKits.some(kit => {
      const babyBirthdate = babyTA?.birthdate;
      if (babyBirthdate) {
        const daysBetween = differenceInCalendarDays(
          parseDate(babyBirthdate),
          parseDate(kit.sample_date),
        );
        if (daysBetween >= -210 && daysBetween <= 210) {
          //this means kit while pregnant or post_partum
          return true;
        }
      }
      return false;
    });

    if (momKitsMatchingCriteria) {
      matchSeedingCriteria = true;
    }
  } else {
    //the current kit is the mom kit
    momTA = currentTinyAccount;
    matchSeedingCriteria = false; //always show placeholder for mother's kit
  }

  return {
    babyTA,
    momTA,
    matchSeedingCriteria,
  };
};
export default useSeedingInfo;
